import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { Reveal, ScrubText } from "./Motion";
import { EASE } from "../../lib/scroll";

const Row = ({ item, i, open, setOpen, labels }) => {
  const active = open === i;
  return (
    <Reveal delay={0.05 * i}>
      <div
        data-testid={`service-card-${i}`}
        onMouseEnter={() => setOpen(i)}
        onClick={() => setOpen(active ? null : i)}
        className="group relative cursor-pointer border-t border-black/10 py-8 transition-colors duration-500 hover:bg-black/[0.02] md:py-10"
      >
        <div className="grid items-start gap-6 md:grid-cols-12">
          <span className={`font-display text-5xl font-light tabular-nums transition-colors duration-500 md:col-span-2 md:text-7xl ${active ? "gold-text" : "text-black/15"}`}>{String(i + 1).padStart(2, "0")}</span>
          <h3 className="font-display text-2xl font-bold tracking-tight md:col-span-6 md:text-4xl">{item.title}</h3>
          <div className="md:col-span-4 md:text-right">
            <ArrowUpRight className={`inline h-6 w-6 transition-[transform,color] duration-500 ${active ? "translate-x-1 -translate-y-1 text-[#8c6b1f]" : "text-black/30"}`} />
          </div>
        </div>
        <AnimatePresence initial={false}>
          {active && (
            <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.6, ease: EASE }} className="overflow-hidden md:grid md:grid-cols-12">
              <div className="pt-5 md:col-span-10 md:col-start-3" data-testid={`service-desc-${i}`}>
                <p className="text-sm leading-relaxed text-black/70 md:text-lg">{item.desc}</p>
                <dl className="mt-5 grid gap-4 sm:grid-cols-3">
                  {[[labels.problem, item.problem], [labels.deliverable, item.deliverable], [labels.next, item.next]].map(([k, v]) => (
                    <div key={k} className="border-t border-black/10 pt-3"><dt className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8c6b1f]">{k}</dt><dd className="mt-1 text-sm leading-relaxed text-black/75">{v}</dd></div>
                  ))}
                </dl>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Reveal>
  );
};

export const Services = () => {
  const { t } = useLang();
  const s = t.services;
  const [open, setOpen] = useState(0);
  return (
    <section id="servizi" data-testid="services-section" className="relative bg-[#fafaf7] pb-20 text-[#0a0a0b] md:pb-28">
      <div className="wrap">
        <div className="pt-20 md:pt-28">
          <p className="eyebrow mb-10" style={{ color: "#8c6b1f" }}>{s.eyebrow}</p>
          <ScrubText key={s.intro} text={s.intro} className="max-w-5xl font-display text-2xl font-medium tracking-tight sm:text-4xl lg:text-[3.2rem] !leading-[1.22]" />
        </div>
        <div className="mt-14 border-b border-black/10 md:mt-20" onMouseLeave={() => setOpen(open)}>
          {s.items.map((it, i) => <Row key={it.title} item={it} i={i} open={open} setOpen={setOpen} labels={s.labels} />)}
        </div>
      </div>
    </section>
  );
};
